// extracted by mini-css-extract-plugin
export var answer = "bB_gL";
export var arrow = "bB_9";
export var body = "bB_g";
export var category = "bB_cK";
export var contactIcons = "bB_gD";
export var current = "bB_ft";
export var fade = "bB_gH";
export var footer = "bB_cF";
export var footerText = "bB_cG";
export var icon = "bB_bw";
export var iconContainer = "bB_b1";
export var issue = "bB_gK";
export var issueContainer = "bB_gG";
export var issueText = "bB_gJ";
export var issues = "bB_gF";
export var left = "bB_bS";
export var padding = "bB_dD";
export var right = "bB_bV";
export var section = "bB_b";
export var selectors = "bB_d5";
export var subtitle = "bB_cV";
export var title = "bB_f";